import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/admin-console/tools/')({
    beforeLoad: () => {
        throw redirect({ to: '/admin-console/tools/document-to-markdown', replace: true });
    },
});
